/**
 * @generated SignedSource<<d61ae3ef09410cda66bcc930f549ad7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HideAgenticWorkerResultInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type HideAgenticWorkerResultMutation$variables = {
  input: HideAgenticWorkerResultInput;
};
export type HideAgenticWorkerResultMutation$data = {
  readonly hideAgenticWorkerResult: {
    readonly result: {
      readonly id: string;
      readonly hidden: boolean;
    } | null;
  } | null;
};
export type HideAgenticWorkerResultMutation = {
  variables: HideAgenticWorkerResultMutation$variables;
  response: HideAgenticWorkerResultMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "HideAgenticWorkerResultPayload",
    "kind": "LinkedField",
    "name": "hideAgenticWorkerResult",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AgenticWorkerResult",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hidden",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HideAgenticWorkerResultMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HideAgenticWorkerResultMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "801298207cc1c7271812a0bb5cb25003",
    "id": null,
    "metadata": {},
    "name": "HideAgenticWorkerResultMutation",
    "operationKind": "mutation",
    "text": "mutation HideAgenticWorkerResultMutation(\n  $input: HideAgenticWorkerResultInput!\n) {\n  hideAgenticWorkerResult(input: $input) {\n    result {\n      id\n      hidden\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7f3abc647b0ce54ef6a9ba6852a96462";

export default node;
